<template>
  <el-dialog class="track-dialog" title="轨迹" :visible="visible" @close="close" :close-on-click-modal="false">
    <div v-if="gpsdata.length > 0">
      <el-slider v-model="range" :max="gpsdata.length" :format-tooltip="formatTooltip" range></el-slider>
    </div>
    <div id="track-dialog-tdt" ref="mapEl"></div>
  </el-dialog>
</template>

<script>
import { loadTianditu } from '@/utils/tianditu'
export default {
  props: {
    gpsdata: {
      type: Array,
      required: true,
      default: function () {
        return []
      }
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      wuhanCenter: [114.279737, 30.563086],
      range: [0, 0],
      zoom: 14,
      map: null,
      polyline: null
    }
  },
  watch: {
    gpsdata (val) {
      if (this.gpsdata.length > 0) {
        this.range = [0, this.gpsdata.length]
      } else {
        this.range = [0, 0]
      }
    }
    ,
    visible (val) {
      if (val) {
        this.$nextTick(() => {
          this.initMap()
        })
      }
    },
    lonLat: {
      handler () {
        this.renderPolyline()
      },
      deep: true
    }
  },
  computed: {
    lonLat () {
      if (this.gpsdata.length === 0) {
        return []
      }
      let arr = this.gpsdata.slice(this.range[0], this.range[1] + 1)
      return arr.map(d => d.lonlat)
    },
    center () {
      if (this.gpsdata.length > 0) {
        return this.gpsdata[0].lonlat
      }
      return this.wuhanCenter
    }
  },
  methods: {
    async initMap () {
      try {
        await loadTianditu()
        if (!this.$refs.mapEl) return
        if (this.map) {
          // 重新显示弹窗时，确保视野正确
          this.renderPolyline()
          return
        }
        const T = window.T
        this.map = new T.Map(this.$refs.mapEl)
        this.map.centerAndZoom(new T.LngLat(this.center[0], this.center[1]), this.zoom)
        this.map.enableScrollWheelZoom()
        if (T.Control && T.Control.Zoom) {
          this.map.addControl(new T.Control.Zoom())
        }
        this.renderPolyline()
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
      }
    },
    renderPolyline () {
      if (!this.map || !window.T) return
      const T = window.T
      this.map.clearOverLays()
      this.polyline = null

      if (!this.lonLat || this.lonLat.length === 0) {
        this.map.centerAndZoom(new T.LngLat(this.center[0], this.center[1]), this.zoom)
        return
      }

      const points = this.lonLat.map(p => new T.LngLat(p[0], p[1]))
      this.polyline = new T.Polyline(points, {
        color: '#0000FF',
        weight: 3,
        opacity: 0.8,
        lineStyle: 'solid'
      })
      this.map.addOverLay(this.polyline)
      this.map.setViewport(points)
    },
    close () {
      this.$emit('close')
    },
    formatTooltip (val) {
      if (this.gpsdata.length === 0) {
        return val
      }
      if (!val) {
        return ''
      }
      if (val < this.gpsdata.length) {
        return this.gpsdata[val].gps_time
      }
      if (val === this.gpsdata.length) {
        return this.gpsdata[val - 1].gps_time
      }
      return val
    }
  },
  beforeDestroy () {
    if (this.map && this.map.clearOverLays) {
      this.map.clearOverLays()
    }
    this.map = null
    this.polyline = null
  }
}
</script>

<style>
#track-dialog-tdt {
  height: 300px;
}
.dialog-footer {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/rent/TrackDialog.vue